import { render } from "./BlockerComputedTable.vue?vue&type=template&id=ff50e694"
import script from "./BlockerComputedTable.vue?vue&type=script&lang=js"
export * from "./BlockerComputedTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__